// extracted by mini-css-extract-plugin
export default {"main":"CusstonTermsOfServicePage_main__kRsPW"};